/*
Square Grommets

  --width <float> | inches
  --length <float> | inches
*/
import grommetFormFields from '@/modules/standardItems/schemas/hardware/grommets/form'
import { length, width } from '@/modules/standardItems/schemas/baseFormFields'

export default [
  ...grommetFormFields,
  length(),
  width()
]
